let resumeData = {
  imagebaseurl: "",
  name: "Stephen Bilham",
  linkedinId: "Your LinkedIn Id",
  skypeid: "Your skypeid",
  roleDescription: "Full Stack Software Developer",
  socialLinks: [
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/srbilham/",
      className: "fa fa-linkedin"
    },
    {
      name: "github",
      url: "https://github.com/stephenbilham",
      className: "fa fa-github"
    }
  ],
  aboutme:
    "	I am a web developer based out of San Diego, California, able to create a web presence from the ground up — from conception to strategic planning, implementation, proper navigation, and programming to optimally improve UX. I aim towards writing efficient, readable, and testable code while using the current best practices in web development. My optimistic and innovative mindset inevitably has driven me towards a passion for problem solving and creativity, as well as an array of other strengths such as being determined, persistent, hard working, a fast learner, and a team player proficient of a variety of scripting languages and frameworks.",
  address: "San Diego",
  education: [
    {
      UniversityName: "University of California, San Diego",
      specialization:
        "The Bachelor of Arts (BA) degree program in Communications",
      MonthOfPassing: "June",
      YearOfPassing: "2017 - 2019",
      Achievements: "Some Achievements"
    },
    {
      UniversityName: "Santa Barbara City College",
      specialization: "Communication Studies",
      MonthOfPassing: "Aug",
      YearOfPassing: "2014 - 2017",
      Achievements: "Some Achievements"
    }
  ],
  work: [
    {
      CompanyName: "Learn Academy",
      specialization: "Full Stack Software Development",
      MonthOfLeaving: "Sept - Jan",
      YearOfLeaving: "2019 - 2020",
      Achievements: "Some Achievements"
    },
    {
      CompanyName: "Some Company",
      specialization: "Some specialization",
      MonthOfLeaving: "Jan",
      YearOfLeaving: "2018",
      Achievements: "Some Achievements"
    }
  ],
  skillsDescription: "Your skills here",
  skills: [
    {
      skillname: "HTML5"
    },
    {
      skillname: "CSS"
    },
    {
      skillname: "JavaScript"
    },
    {
      skillname: "React"
    },
    {
      skillname: "Ruby"
    },
    {
      skillname: "Ruby on Rails"
    },
    {
      skillname: "SQL"
    },
    {
      skillname: "AWS"
    },
    {
      skillname: "Github"
    }
  ],
  portfolio: [
    {
      name: "OmniFood",
      description:
        "Food delivery application that involves fluid grids, proper design techniques, positioning, media queries, Jquery, and much more. This project is responsive on web, tablets and iPhones of all sizes.",
      imgurl: "https://media.giphy.com/media/hvLOGi1KsF02XiZ1DD/giphy.gif",
      url: "https://stephenbilham.github.io/SbOmniFood/",
      type: ["html"]
    },
    {
      name: "Forkify",
      description:
        "Here you can search through an API of recipes and add your favorites to a shopping list/favorite recipes (ingredients change with serving size). This was a complex app, using Async functions, fetch, await, callbacks, and closures",
      imgurl: "https://media.giphy.com/media/ekeOYzzNEpW73RIcSb/giphy.gif",
      url:
        "https://github.com/stephenbilham/Financial-budgeting-App/tree/master/Budgety/Starter",
      type: ["html", "javascript"]
    },
    {
      name: "Connect Four",
      description:
        "This was logically challenging. The hardest part was finding all of the winning combinations using mathamatical algorithims/trial and error. The stetch goal is to add animation for the connect four pieces to fall.",
      imgurl: "https://media.giphy.com/media/YrC2lEAcG4loOj2aLI/giphy.gif",
      url: "https://github.com/stephenbilham/Connect-four",
      type: ["react", "html", "javascript"]
    },
    {
      name: "Laptop Store",
      description:
        "Node Js practice where the purpose was to learn how to properly route based on filesharing/URL/ID's and rendering a cool looking laptop store application. This was the first introduction that I had to Node JS. ",
      imgurl: "https://media.giphy.com/media/VGKPGZX3F2fDzC3zxX/giphy.gif",
      url: "https://github.com/stephenbilham/LaptopStore",
      type: ["nodejs"]
    },
    {
      name: "DOM-Pig-Game",
      description:
        "Two player game using JS functionality and JS selctors to change the CSS properties. Goal of the game it to get to a score of user choice if double 6's global score is reset. if you role a 1 then it's switches players.",
      imgurl: "https://media.giphy.com/media/YoPoDkMWH8gXzhY7Ll/giphy.gif",
      url: "https://github.com/stephenbilham/DOM-pig-game/tree/master/starter",
      type: ["javascript"]
    },
    {
      name: "Budget Tracker",
      description:
        "Allows users to track their monthly/ annual budgets. I use module patterns for clean, sectioned code and JavaScript concepts such as closures, prototypes, anonymous functions, and callbacks.",
      imgurl: "https://media.giphy.com/media/jRN2RVW71ArjDWe5KC/giphy.gif",
      url: "https://github.com/stephenbilham/Financial-budgeting-App",
      type: ["html", "javascript"]
    },
    {
      name: "Apartment Finder",
      description:
        "Project in progress (REST/CRUD architecture). You are able to create a personal account/sign-in with devise. Once signed in, you can create a listing for an apartment which is stored to that user.",
      imgurl: "https://media.giphy.com/media/WscWy0lw7k0kkojUYh/giphy.gif",
      url: "https://github.com/stephenbilham/ApartmentFinder",
      type: ["react", "ruby on rails"]
    },
    {
      name: "Tic-Tac-Toe",
      description:
        "This was a fun game to build, although many think it is over done, it surely tests ones logic skills while learning how to code.",
      imgurl: "https://media.giphy.com/media/U6derfInQGT7XS7IP7/giphy.gif",
      url: "https://github.com/stephenbilham/Tic-tac-toe-",
      type: ["react"]
    }
  ]
};

export default resumeData;
